import api from '../../../api/index';

export default {
  definePassword({ rootGetters }, value) {
    return api.put('user/define-password', value, {
      headers: {
        Authorization: `Bearer ${rootGetters.getToken}`,
      },
    });
  },
  consultCep({}, cep) {
    return api.get(`cep/${cep}/consult`);
  },
  validarCnpj({}, cnpj) {
    return api.get(`cnpj/${cnpj}/consult`);
  },
  validarCpf({}, cpf) {
    return api.get(`cpf/${cpf}/consult`);
  },
  validarEmail({}, data) {
    return api.post(`email/consult`, data);
  }
};
